import { render, staticRenderFns } from "./ThesisSelectbox.vue?vue&type=template&id=963c1f84"
import script from "./ThesisSelectbox.vue?vue&type=script&lang=js"
export * from "./ThesisSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports